import "./assignProjectList.css"; // reused CSS for exact styling
import "./assignProjectCatalogue.css"; // reused CSS for exact styling
import React, { useEffect, useState } from "react";
import SearchBar from "../Main/searchBar";
import { Link } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import {
  listFranchiseCatalogues,
  revokeCatalogueAssignment,
} from "../../Redux/Actions/franchiseAction";
import { Pagination } from "antd";

const AssignProjectCatalogue = () => {
  const { selectedFranchiseId: franchiseId } = useSelector(
    (state) => state.franchises
  );
  const dispatch = useDispatch();

  const [projectList, setProjectList] = useState([]);
  const [isLoadingProjects, setIsLoadingProjects] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  // Modal state
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalUnits, setModalUnits] = useState([]);

  useEffect(() => {
    if (franchiseId) {
      fetchProjectList(pagination.current, pagination.pageSize);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [franchiseId]);

  const fetchProjectList = async (page, pageSize) => {
    setIsLoadingProjects(true);
    try {
      const payload = {
        franchise_id: franchiseId,
        is_deleted: false,
        page,
        limit: pageSize,
      };
      const res = await dispatch(listFranchiseCatalogues(payload));
      if (res && res.data && Array.isArray(res.data)) {
        setProjectList(res.data);
        setPagination((prev) => ({
          ...prev,
          current: page,
          pageSize,
          total: res.total ?? 0,
        }));
        if (res.data.length === 0)
          toast("No projects found for this franchise.");
      } else {
        setProjectList([]);
        setPagination((prev) => ({ ...prev, total: 0 }));
        toast("No projects found for this franchise.");
      }
    } catch {
      toast.error("Failed to fetch projects");
      setProjectList([]);
      setPagination((prev) => ({ ...prev, total: 0 }));
    } finally {
      setIsLoadingProjects(false);
    }
  };

  const openUnitsModal = (units) => {
    setModalUnits(units || []);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalUnits([]);
  };

  const hasLaneData = modalUnits.some(
    (unit) => unit.lane !== null && unit.lane !== undefined && unit.lane !== ""
  );
  const hasFloorData = modalUnits.some(
    (unit) =>
      unit.floor !== null && unit.floor !== undefined && unit.floor !== ""
  );

  const handleRevokeCatalogue = async (item) => {
    const payload = {
      builder: (item.builder && (item.builder._id || item.builder)) || "",
      project: (item.project && (item.project._id || item.project)) || "",
      franchise: franchiseId || "",
      catalogue: (item.catalogue && item.catalogue._id) || "",
    };

    if (
      !payload.builder ||
      !payload.project ||
      !payload.franchise ||
      !payload.catalogue
    ) {
      toast.error("Missing necessary IDs to revoke assignment");
      return;
    }

    try {
      const res = await dispatch(revokeCatalogueAssignment(payload));
      if (res && res.statusCode === 200) {
        toast.success("Catalogue assignment revoked successfully");
        fetchProjectList(pagination.current, pagination.pageSize);
      } else {
        toast.error(res.message || "Failed to revoke catalogue assignment");
      }
    } catch {
      toast.error("Failed to revoke catalogue assignment");
    }
  };

  return (
    <div className="grid-container">
      <div
        className="padding-20"
        style={{ gridColumn: "3/8", marginBottom: 20 }}
      >
        <SearchBar style={{ width: "max-content" }} />
      </div>

      <div
        style={{
          gridColumn: "span 7",
          marginBottom: 10,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          paddingRight: 16,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 16,
            flexShrink: 0,
          }}
        >
          <Link to="/franchise/assign_projects">
            <BackIcon style={{ cursor: "pointer", width: 80, height: 80 }} />
          </Link>
          <h3 style={{ margin: 0, fontWeight: 600, color: "#181E2E" }}>
            Project Catalogue Assigned
          </h3>
        </div>

        <Link
          to="/franchise/assign_projects"
          style={{
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            height: 66,
            width: 200,
            backgroundColor: "#181E2E",
            color: "#fff",
            textDecoration: "none",
            fontWeight: "bold",
            borderRadius: 32,
            cursor: "pointer",
          }}
          className="assign-builder-link"
        >
          Assigned Project List
        </Link>
      </div>

      <div className="overall-container">
        <div
          className={`builder-list-wrapper ${
            projectList.length === 0 && !isLoadingProjects ? "centered" : ""
          }`}
        >
          {isLoadingProjects ? (
            <div className="loader">Loading projects...</div>
          ) : projectList.length > 0 ? (
            <>
              <table className="builder-table">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Project ID</th>
                    <th>Project Name</th>
                    <th>Brand Name</th>
                    <th>Created At</th>
                    <th>Catalogue ID</th>
                    <th>Tower Name</th>
                    <th>Site Name</th>
                    <th>Units</th>
                  </tr>
                </thead>
                <tbody>
                  {projectList.map((item, index) => (
                    <tr key={item._id || index}>
                      <td>
                        {(pagination.current - 1) * pagination.pageSize +
                          index +
                          1}
                      </td>
                      <td>{item.project?.project_id ?? "No Data"}</td>
                      <td>{item.project?.project_name ?? "No Data"}</td>
                      <td>{item.builder?.brand_name ?? "No Data"}</td>
                      <td>
                        {new Date(
                          item.created_at || item.updated_at
                        ).toLocaleDateString(undefined, {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </td>
                      <td>{item.catalogue?._id ?? "No Data"}</td>
                      <td>{item.catalogue?.tower_name ?? "No Data"}</td>
                      <td>{item.catalogue?.site_name ?? "No Data"}</td>
                      <td>
                        <button
                          onClick={() => openUnitsModal(item.units)}
                          className="units-show-button"
                        >
                          Show Units ▼
                        </button>

                        <button
                          onClick={() => handleRevokeCatalogue(item)}
                          style={{
                            marginLeft: 10,
                            backgroundColor: "red",
                            color: "white",
                            border: "none",
                            borderRadius: 4,
                            padding: "5px 10px",
                            cursor: "pointer",
                          }}
                        >
                          Revoke
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <Pagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                showSizeChanger
                pageSizeOptions={["5", "10", "15", "20"]}
                onChange={(page, pageSize) => {
                  setPagination((prev) => ({
                    ...prev,
                    current: page,
                    pageSize,
                  }));
                  fetchProjectList(page, pageSize);
                }}
                style={{ marginTop: 20, textAlign: "center"}}
              />

              {isModalOpen && (
                <div className="custom-modal-backdrop" onClick={closeModal}>
                  <div
                    className="custom-modal-content"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <h3 className="custom-modal-title">Units Details</h3>

                    <button
                      className="custom-modal-close-button"
                      onClick={closeModal}
                    >
                      Close
                    </button>

                    <div className="units-table-wrapper">
                      <table className="custom-units-table">
                        <thead>
                          <tr>
                            <th>Unit Type</th>
                            <th>Unit No</th>
                            <th>Floor</th>
                            <th>Lane</th>
                          </tr>
                        </thead>
                        <tbody>
                          {modalUnits && modalUnits.length > 0 ? (
                            modalUnits.map((unit, idx) => (
                              <tr key={idx}>
                                <td>{unit.unit ?? "No Data"}</td>
                                <td>
                                  {unit.unitno ?? unit.unitNo ?? "No Data"}
                                </td>
                                <td>{unit.floor ?? "No Data"}</td>
                                <td>{unit.lane ?? "No Data"}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={3}>No units available</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}
            </>
          ) : (
            <div
              style={{
                textAlign: "center",
                fontSize: 18,
                color: "rgba(255,255,255,0.7)",
                padding: 30,
              }}
            >
              No projects found for this franchise.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AssignProjectCatalogue;
